.pageContainer {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  &.pageIsLoading .page .pageContect {
    overflow: hidden;
  }
  .page {
    height: 100%;
    max-height: 100%;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .pageContect {
      padding: 24px 0;
      height: calc(100% - 64px);
      overflow-y: auto;

      &.noPadding {
        padding: 0;
      }
    }

    .pageHeaderContainer {
      align-items: center;
      position: relative;

      .pageHeader {
        margin: 0;
        margin-bottom: 12px;
        text-align: center;
      }

      .backArrow {
        position: absolute;
        left: 24px;
        cursor: pointer;
        font-size: 18px;
        pointer-events: all;
        top: 0;
      }
    }
  }
}

.pageFooter {
  margin-top: auto;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  height: 64px;
  grid-template-columns: 1fr auto 1fr;
  box-sizing: border-box;
  @include themify($themes) {
    border-top: solid 1px themed("neutral-secondary");
  }

  &.oneButton {
    justify-content: center;
  }
}

.loadingContainer {
  position: absolute;
  height: calc(100% + 24px);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -24px;
  z-index: 1;
  flex-direction: column;
  user-select: none;
  opacity: 1;

  @include themify($themes) {
    background: themed("main-secondary");
    color: themed("main-primary");
  }

  &.hideLoading {
    opacity: 0;
    transition: opacity 0.25s ease-out;
    pointer-events: none;
  }
}
